export const environment = {
    production: true,
    apiUrl: 'https://api.crm.test.asbl.in/api',
    apiV2Url: 'https://api.crm.test.asbl.in/api/v2',
    useOtp: true,
    ioSocketUrl: 'https://api.crm.test.asbl.in',
    node_env: 'Test',
    customerPortalLink: 'https://test.customer.asbl.in',
    periskopeConsoleOrigin: 'https://console.periskope.app',
    periskopeChatIframeQueryParams: 'rightPanel=0',
    posthogApiKey: 'phc_64SVGL9fatbFrraFyxbfLcch5UO8QkyEX9pm1WXBiD2',
    posthogHost: 'https://eu.i.posthog.com',
};
